<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p>
        {{ $t('maintenance.reminderSender.desc') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex justify-content-end">
          <McButton
            variant="secondary"
            class="me-2"
            @click="$router.push({ name: 'History Email Service Alert' })"
            icon="icon-outline_file-text"
            :text="$t('report.title.deliveryHistory')"
          />
          <McButton
            variant="secondary"
            @click="$router.push({ name: 'List Service Alert' })"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <!-- Table -->
        <div class="table-responsive my-3">
          <McGrapqlTable
            :apiClient="query"
            :fields="fields"
            :customHandlers="customHandlers"
            :hasCheckbox="true"
            :searchable="true"
            :withCard="true"
            :isSelectableField="false"
            trackBy="reportSchedulerId"
            class="mc-table--detail"
          >
            <template #thead-top>
              <b-tr>
                <b-th><span class="checkbox"></span></b-th>
                <b-th rowspan="2">
                  <div class="d-flex align-items-center">
                    {{ $t('maintenance.field.scheduleName') }}
                  </div>
                </b-th>
                <b-th rowspan="2">
                  <div class="d-flex align-items-center">
                    {{ $t('maintenance.field.schedulingPeriod') }}
                  </div>
                </b-th>
                <b-th colspan="2" class="text-center">
                  {{ $t('maintenance.field.reminderRecipients') }}
                </b-th>
              </b-tr>
            </template>

            <template #cell(period)="data">
              {{ data.value === 'd' ? $t('global.time.daily') : $t('global.time.weekly') }}{{ ' - '
              }}{{ getDayName(data.item.noOfDay) }}{{ data.item.noOfDay ? ', ' : ' '
              }}{{ getTime(data) }}
            </template>
            <template #cell(whatsapp)="data">
              {{ data.item.aggregate.whatsapp }}
            </template>
            <template #cell(email)="data">
              {{ data.item.aggregate.email }}
            </template>
          </McGrapqlTable>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButton from '@/components/McButton'
import moment from 'moment'
import { GET_REPORT_SCHEDULERS, DELETE_REPORT_SCHEDULER } from '@/services/api/report/report'
import { MixPanel } from '@/mixin/mixpanel'

moment.locale('id')
/**
 * Starter component
 */
export default {
  page: {
    title: 'Pengiriman Email',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButton,
  },
  mixins: [MixPanel],

  data() {
    return {
      show_model: [],
      customHandlers: {
        handleAdd: () => {
          return this.$router.push({ name: 'Email Alert Create' })
        },
        handleClickRow: (item) => {
          return this.$router.push({
            name: 'Email Alert Create',
            params: { id: item.reportSchedulerId },
          })
        },
      },
    }
  },

  computed: {
    title() {
      return `${this.$t('global.reminderDelivery')}`
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceAlert'),
          to: { name: 'List Service Alert' },
        },
        {
          text: this.$t('global.reminderDelivery'),
        },
      ]
    },

    fields() {
      return [
        {
          key: 'scheduleName',
          label: this.$t('maintenance.field.scheduleName'),
          sortable: true,
          isRedirectable: true,
          thClass: 'd-none',
        },
        {
          key: 'period',
          label: this.$t('maintenance.field.schedulingPeriod'),
          sortable: true,
          thClass: 'd-none',
        },
        {
          key: 'whatsapp',
          label: 'WhatsApp',
        },
        {
          key: 'email',
          label: this.$t('notification.setting.emailNotification.email'),
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_REPORT_SCHEDULERS,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                ...filter,
                reportKey: 'serviceReminder',
              },
            },
          })

          return res.data.reportSchedulers.reportSchedulers
        },
        delete: async (filter) => {
          const res = await this.$apollo.query({
            query: DELETE_REPORT_SCHEDULER,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                reportSchedulerIds: Number(filter),
              },
            },
          })

          return res.data.deleteReportScheduler
        },
      }
    },
  },

  mounted() {
    this.track('View Email Sender Page')
  },

  methods: {
    getTime(data) {
      return moment(data.item.time, 'HH:mm:ss').format('HH:mm')
    },

    getDayName(number) {
      let daysArray = [
        this.$t('global.days.sunday'),
        this.$t('global.days.monday'),
        this.$t('global.days.tuesday'),
        this.$t('global.days.wednesday'),
        this.$t('global.days.thursday'),
        this.$t('global.days.friday'),
        this.$t('global.days.saturday'),
      ]
      return daysArray[number]
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox {
  &:before {
    content: '';
    width: 100%;
    background-color: #fafcff;
    height: 4px;
    position: absolute;
    left: 0px;
    top: 39px;
  }
}
</style>
